var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lawlex-custom-card"},[_c('div',{staticClass:"no-data-found-wrapper"},[_c('img',{attrs:{"src":_vm.imageSrc}}),_c('div',[(_vm.isUserNotActive)?_c('div',[_vm._v(_vm._s(_vm.$t('msg_user_not_active')))]):_c('div',[_vm._v(_vm._s(_vm.title))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }